import Dashboard from './pages/Dash.svelte';


const mainRoutes = {
   
    '*' : Dashboard,
}

export default mainRoutes; 